import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Input from "../../../form/Input";

const GridForm = ({ data, setData }) => {
  const handleDragEnd = (result, type) => {
    if (!result.destination) return;

    const items = Array.from(
      type === "rows" ? data?.options?.rows : data?.options?.columns
    );
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    if (type === "rows")
      setData({ options: { rows: items, columns: data?.options?.columns } });
    else
      setData({
        options: { columns: items, rows: data?.options?.rows },
      });
  };

  return (
    <div className="flex gap-4">
      {/* Rows Section */}
      <DragDropContext onDragEnd={(result) => handleDragEnd(result, "rows")}>
        <div className="w-full bg-slate-50 rounded-md space-y-5">
          <div className="p-4 pb-0">Rows</div>
          <Droppable droppableId="rows">
            {(provided) => (
              <ul
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="space-y-5 pb-4"
              >
                {data?.options?.rows.map((item, index) => (
                  <Draggable
                    key={item?.value || index}
                    draggableId={item?.value || index}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <li
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`flex items-center gap-3 group p-2 rounded`}
                      >
                        <div
                          {...provided.dragHandleProps}
                          className="flex items-center justify-center mt-4 opacity-0 group-hover:opacity-100 transition-all duration-200 cursor-move"
                        >
                          <i className="fa-fw fa-solid fa-grip-dots-vertical text-gray-400"></i>
                        </div>
                        <Input label={`Row ${index + 1}`} value={item?.label} />
                        <button
                          type="button"
                          className="text-red-500 mt-4 flex items-center justify-center hover:text-red-500/50"
                        >
                          <i className="fa-fw fa-regular fa-trash-can"></i>
                        </button>
                      </li>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </div>
      </DragDropContext>

      {/* Columns Section */}
      <DragDropContext onDragEnd={(result) => handleDragEnd(result, "columns")}>
        <div className="w-full bg-slate-50 rounded-md space-y-5">
          <div className="p-4 pb-0">Columns</div>
          <Droppable droppableId="columns">
            {(provided) => (
              <ul
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="space-y-5 pb-4"
              >
                {data?.options?.columns.map((item, index) => (
                  <Draggable
                    key={item?.value || index}
                    draggableId={item?.value || index}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <li
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`flex items-center gap-3 group p-2 rounded `}
                      >
                        <div
                          {...provided.dragHandleProps}
                          className="flex items-center justify-center mt-4 opacity-0 group-hover:opacity-100 transition-all duration-200 cursor-move"
                        >
                          <i className="fa-fw fa-solid fa-grip-dots-vertical text-gray-400"></i>
                        </div>
                        <Input
                          label={`column ${index + 1}`}
                          value={item?.label}
                        />
                        <button
                          type="button"
                          className="text-red-500 mt-4 flex items-center justify-center hover:text-red-500/50"
                        >
                          <i className="fa-fw fa-regular fa-trash-can"></i>
                        </button>
                      </li>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </div>
      </DragDropContext>
    </div>
  );
};

export default GridForm;
